import "@/App.css";
import Home from "@/pages/Home";

function App() {
    return (
        <div className="App min-h-screen" style={{ background: "var(--ck-ivory)" }}>
            <Home />
        </div>
    );
}

export default App;
